<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      class="z-10"
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      :includeAdmin="true"
    ></results-bar>
    <results-summary
      v-if="summary"
      :id="doc.id"
      :summaryMode="summaryMode"
      :matrix="matrix"
      :key="doc.id"
      :editMode="editMode"
      :slug="language"
    ></results-summary>
    <results-user
      v-if="!summary"
      :matrix="matrix"
      :uid="currentUser"
      :editMode="editMode"
      :id="doc.id"
      :key="doc.id"
      :slug="language"
    ></results-user>
  </div>
</template>

<script>
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar,
} from "@/components/results/positioning";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultFunctionality",
  props: {
    doc: {
      type: Object,
      default: null,
      editMode: false,
    },
    slug: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
      matrix: null,
    };
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar,
  },
  computed: {
    language() {
      if (this.slug === "competition-matrix-2") {
        return "exercise_competition_matrix_2";
      } else {
        return "exercise_competition_matrix_unique_group_2";
      }
    },
  },
  mounted() {
    this.getExercise();
    this.getUsers();
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
      this.editMode = !this.editMode;
    },
    getUsers() {
      console.log("get users");
      let ref = fb.competitionMatrix2ExCollection.where(
        "pid",
        "==",
        this.doc.id
      );
      ref
        .get()
        .then((result) => {
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
          });
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("get ex");
      let ref = fb.competitionDetailExCollection.where(
        "pid",
        "==",
        this.doc.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.matrix = items[0].doc.matrix;
            this.editMode = !this.editMode;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
